import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { countryIds } from "@mindlercare/schema";
import { DropdownWithSearch } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { useMindlerApi } from "../../api/apiv2";
import { getCountryCode } from "../../helpers/getCountryCode";
import { useSelectedPsychologistIdParam } from "../../hooks/useSelectedPsychologistParam";
import { useUserHasRole } from "../../hooks/userHooks";
import { memo } from "react";

const DELETED = "[DELETED]";

export const PsychologistDropdown = memo(() => {
  const isAdmin = useUserHasRole("Admin");
  const [selectedPsychologistId, setSelectedPsychologistId] =
    useSelectedPsychologistIdParam();

  const { t } = useTranslation();
  const countryCode = getCountryCode();
  const api = useMindlerApi();
  const { data } = useQuery(
    api.psychologists.findAll.queryOptions({
      countryId: countryIds[countryCode],
      includeInactive: true,
    }),
  );

  const items =
    data
      ?.filter(
        (psychologist) => !psychologist.user?.firstName?.includes(DELETED),
      )
      .map((psychologist) => ({
        toString: () =>
          `${psychologist.user?.firstName} ${psychologist.user?.lastName}`,
        id: psychologist.psychologistId,
        userId: psychologist.user.userId,
      })) ?? [];

  return (
    <DropdownWithSearch
      items={items ?? []}
      selectedItemId={isAdmin ? selectedPsychologistId : null}
      noItemsFoundPlaceholder={t("NO_RESULTS_FOUND")}
      searchPlaceholder={t("DROPDOWN_SELECT_PSYCHOLOGIST")}
      filterItems={(value) => {
        return items.filter(
          (item) =>
            item.toString().toUpperCase().includes(value.toUpperCase()) &&
            !item.toString().includes(DELETED),
        );
      }}
      itemToString={(item) => item?.toString() ?? ""}
      onSelectedItemChange={async (selectedItem) => {
        await setSelectedPsychologistId(selectedItem ? selectedItem.id : null);
      }}
    />
  );
});

PsychologistDropdown.displayName = "PsychologistDropdown";
